<script setup lang="ts">
  import {
    onMounted,
    ref,
  } from 'vue'

  import { useContentApi } from '@/composables/useCmsContentApi'
  import { useAppRouting } from '@/composables/useAppRouting'
  import type { AnchorNavigationPage } from '@/types/AnchorNavigationPage'
  import type { SubjectResource } from '@/types/Subject'
  import RouteParam from '@/enums/RouteParam'

  import AnchorNavigationTemplate from '@/components/anchor-navigation/AnchorNavigationTemplate.vue'
  import VgsSpinner from '@/components/common/VgsSpinner.vue'

  const { getContentIdFromRouteParam } = useAppRouting()
  const { getCurrentResourceGuide, getCurrentElement } = useContentApi()

  const isLoading = ref<boolean>(false)
  const currentSubjectResource = ref<SubjectResource | null>(null)
  const currentResourceGuide = ref<AnchorNavigationPage | null>(null)

  onMounted(async () => {
    isLoading.value = true
    currentSubjectResource.value = await getCurrentElement(getContentIdFromRouteParam(RouteParam.SubjectResource))
    currentResourceGuide.value = await getCurrentResourceGuide(getContentIdFromRouteParam(RouteParam.ResourceGuide))
    isLoading.value = false
  })
</script>

<template>
  <VgsSpinner :is-loading="isLoading" />
  <AnchorNavigationTemplate
    v-if="currentResourceGuide"
    :content="currentResourceGuide"
    :top-section-title="currentSubjectResource?.title"
    :top-section-super-title="currentSubjectResource?.category"
  />
</template>
